import { useState } from 'react';
import { useScopedNavigate } from '@/app/providers/TenantScopeProvider';

// Шинэ feature нэмэгдэх бүрд энэ version-ыг ахиулна — улаан "шинэ" цэг дахин
// гарч хэрэглэгчдэд шинэчлэл болсныг сануулна. localStorage-д сүүлд үзсэн
// version хадгална.
const WHATS_NEW_VERSION = '2026-05';
const SEEN_KEY = 'tsetsu.whatsNewSeen';

/**
 * Header-ийн "Шинэчлэл" (what's new) badge. Бүтээгдэхүүний замналын (roadmap)
 * хуудас руу шилжүүлнэ. Урьд нь зүүн talбарын "Тусламж" хэсэгт "Замнал"
 * нэрээр байсныг header-руу шилжүүлэв.
 */
export function WhatsNewBadge() {
  const nav = useScopedNavigate();
  const [seen, setSeen] = useState(
    () => localStorage.getItem(SEEN_KEY) === WHATS_NEW_VERSION,
  );

  function handleClick() {
    localStorage.setItem(SEEN_KEY, WHATS_NEW_VERSION);
    setSeen(true);
    nav('roadmap');
  }

  return (
    <button
      type="button"
      className="ts-whatsnew-btn"
      onClick={handleClick}
      title="Шинэчлэл ба бүтээгдэхүүний замнал"
      aria-label="Шинэчлэл"
    >
      <i className="bi bi-megaphone" />
      <span className="ts-whatsnew-label">Шинэчлэл</span>
      {!seen ? <span className="ts-whatsnew-dot" aria-hidden="true" /> : null}
    </button>
  );
}
